
<template>
  <div>
    <NavBar />
    <StripeUnlimitedPurchase />
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';
import StripeUnlimitedPurchase from '@/components/StripeUnlimitedPurchase.vue'
import { ref } from 'vue';

export default {
  name: 'GetUnlimitedView',
  components: {
      NavBar,
      StripeUnlimitedPurchase
  },
  data() {
    return {

    }
  },
}
</script>
<style>
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}

/*.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/home-background.png'); 
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}*/
</style>